module.exports = __webpack_public_path__ + "img/details1.3c86861d.png";